import { useState } from "react";
import Header from "../components/Header";
import Footer from "../components/Footer";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import { Label } from "../components/ui/label";
import { Alert, AlertDescription } from "../components/ui/alert";
import { AlertCircle } from "lucide-react";
import { trackLoginAttempt } from "../lib/tracking";

export default function Login() {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState(false);
  const [submitting, setSubmitting] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    // Protection anti-bot : honeypot rempli => on ignore silencieusement
    if (e.target.website && e.target.website.value) {
      setError(true);
      return;
    }
    // Rate limiting côté client (max 5 tentatives / 5 min)
    try {
      const now = Date.now();
      const raw = JSON.parse(sessionStorage.getItem("login_attempts") || "[]");
      const recent = raw.filter((t) => now - t < 5 * 60 * 1000);
      if (recent.length >= 5) {
        setError(true);
        return;
      }
      recent.push(now);
      sessionStorage.setItem("login_attempts", JSON.stringify(recent));
    } catch (_) {}

    setSubmitting(true);
    setError(false);
    trackLoginAttempt();
    await new Promise((r) => setTimeout(r, 500));
    setError(true);
    setSubmitting(false);
  };

  return (
    <main className="min-h-screen flex flex-col">
      <Header />
      <section className="flex-1 pt-32 pb-16 lg:pt-40 lg:pb-24 bg-gradient-to-br from-blue-50/40 via-background to-blue-100/30 relative">
        <div className="absolute inset-0 bg-gradient-to-r from-blue-500/5 via-transparent to-blue-400/5 pointer-events-none"></div>
        <div className="container mx-auto px-4 lg:px-8 relative z-10">
          <div className="max-w-sm mx-auto">
            <div className="bg-card border border-border rounded-2xl shadow-xl p-6 lg:p-8">
              <div className="text-center mb-8">
                <div className="flex justify-center mb-6">
                  <div className="relative w-32 h-10">
                    <img src="/Certif/Logo.png" alt="Logo" className="w-full h-full object-contain" />
                  </div>
                </div>
                <h1 className="text-3xl lg:text-4xl font-bold text-foreground mb-3">Connexion</h1>
                <p className="text-muted-foreground">Accédez à votre espace client</p>
              </div>
              <form onSubmit={submit} className="space-y-6" autoComplete="off" noValidate>
                {/* Honeypot anti-bot (invisible aux humains) */}
                <input type="text" name="website" tabIndex="-1" autoComplete="off" style={{ position: "absolute", left: "-9999px", width: 1, height: 1, opacity: 0 }} aria-hidden="true" />
                {error && (
                  <Alert variant="destructive">
                    <AlertCircle className="h-4 w-4" />
                    <AlertDescription>Votre identifiant ou mot de passe est incorrect.</AlertDescription>
                  </Alert>
                )}
                <div className="space-y-2">
                  <Label htmlFor="username" className="text-base font-semibold">Identifiant</Label>
                  <Input id="username" type="text" placeholder="Entrez votre identifiant" value={username} onChange={(e) => setUsername(e.target.value)} required maxLength={100} autoComplete="username" className="h-11" />
                </div>
                <div className="space-y-2">
                  <Label htmlFor="password" className="text-base font-semibold">Mot de passe</Label>
                  <Input id="password" type="password" placeholder="Entrez votre mot de passe" value={password} onChange={(e) => setPassword(e.target.value)} required maxLength={200} autoComplete="current-password" className="h-11" />
                </div>
                <div className="flex items-center text-sm">
                  <label className="flex items-center gap-2 cursor-pointer">
                    <input type="checkbox" className="w-4 h-4 rounded border-border" />
                    <span className="text-muted-foreground">Se souvenir de moi</span>
                  </label>
                </div>
                <Button type="submit" className="w-full h-11 text-base shadow-lg hover:shadow-xl hover:scale-[1.02] transition-all duration-300" disabled={submitting}>
                  {submitting ? "Connexion..." : "Se connecter"}
                </Button>
              </form>
            </div>
          </div>
        </div>
      </section>
      <Footer />
    </main>
  );
}
